import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

//import axios from 'axios';
import axios_api from '../Api';

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';




function TaskLink({task}){
  console.log(task)
  return (
    <>
      <p><Link to={`/task/` + task.id}>{task.form}</Link></p>
    </>
  )
}


export default function TaskList ({selectedYear}){

  const[tasks, setTasks] = useState([]);
  const navigate = useNavigate();
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {

    let taskList = axios_api.get(api_url + '/user_tasks', {
      headers: {"Authorization": token},
      params: {"year": selectedYear}
    });

    taskList.then(
      (result) => {
        //console.log(result);
        setTasks(result.data);
      },
      (error) => {
        console.log(error)
      }
    );

  }, []);

  let rows = [];
  for (let i in tasks) {
    rows.push(
      <TaskLink 
        key={i} 
        task={tasks[i]}
      />
    ); 
  }

  return (
    <>
      <div className="row">
        <h3 className="m-3">Формы ввода результатов исследований</h3>
      </div>
      <div className="row m-3">
        {rows}
      </div>
    </>
  )
}